import ThreeDSecureFrame from "./ThreeDSecureFrame";
import Controller from "../controller/Controller";
import { Token } from "../types/response/Token";
import { ErrorResponse } from "../types/response/ErrorResponse";
import { ThreeDSecureOptions } from "../types/SecurionPayOptions";
import { ThreeDSecureFrameParams } from "./ThreeDSecureFrameParams";
import { getFrameAbsoluteUrl } from "../resourceUrls";


export default class ThreeDSecure {

    constructor(
        readonly _apiUrl: string,
        readonly _key: string,
        readonly _jsId: string,
        readonly _controller: Controller,
        readonly _options?: ThreeDSecureOptions,
    ) {
    }

    verifyThreeDSecure(request): Promise<Token | ErrorResponse> {
        const params: ThreeDSecureFrameParams = {
            publicKey: this._key,
            apiUrl: this._apiUrl,
            jsId: this._jsId
        };
        if (this._options?.merchantId) {
            params.merchantId = this._options.merchantId
        }
        if (this._options?.merchantAccountId) {
            params.merchantAccountId = this._options.merchantAccountId
        }
        const frame = new ThreeDSecureFrame(getFrameAbsoluteUrl('3d-secure/inner.html'), this._controller._id, params);
        frame.appendTo(document.body);
        this._controller.addFrame(frame);

        return frame
            .action("verify-threed-secure", {request: request})
            .then(response => {
                frame.destroy();
                return response;
            });
    }
}
